import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import FooterLinks from "../components/FooterLinks";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/produkte" replace />;
  const submit = async (event) => {
    event.preventDefault(); setError(""); setBusy(true);
    try { await login(email, password); navigate("/produkte"); }
    catch (err) { setError(err.response?.data?.detail || "Login fehlgeschlagen"); }
    finally { setBusy(false); }
  };
  return <main className="login-page" data-testid="login-page">
    <section className="login-card" data-testid="login-card">
      <img className="login-logo-img" src="https://customer-assets.emergentagent.com/job_blueprint-store-3/artifacts/vblfk2l1_DOSA-Shop_Logo.png" alt="DOSA Shop" data-testid="login-logo-image" />
      <p data-testid="login-subtitle">Technische Zeichnungen. Direkte Ersatzteilanfrage.</p>
      <form onSubmit={submit} autoComplete="off" data-testid="login-form">
        <label data-testid="login-email-label"><Mail size={16} /> E-Mail</label><input value={email} name="dosa-login-email" autoComplete="off" onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
        <label data-testid="login-password-label"><Lock size={16} /> Passwort</label><input type="password" value={password} name="dosa-login-password" autoComplete="new-password" onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
        {error && <div className="error" data-testid="login-error-message">{error}</div>}
        <button className="primary-button full" disabled={busy} data-testid="login-submit-button">{busy ? "Anmelden…" : "Anmelden"}</button>
      </form>
    </section>
    <FooterLinks />
  </main>;
}